import capitalize from 'lodash/capitalize';

import {
  StatusChipV2,
  StatusChipV2Color,
  StatusChipV2Props,
} from '@cast/design-system';
import { NotificationSeverity } from '@cast/types';

type Props = Omit<StatusChipV2Props, 'label' | 'color' | 'variant'> & {
  severity: NotificationSeverity | '';
};

const severityToColor: Record<NotificationSeverity, StatusChipV2Color> = {
  [NotificationSeverity.UNSPECIFIED]: 'neutral',
  [NotificationSeverity.CRITICAL]: 'error',
  [NotificationSeverity.ERROR]: 'error',
  [NotificationSeverity.WARNING]: 'warning',
  [NotificationSeverity.INFO]: 'info',
  [NotificationSeverity.SUCCESS]: 'success',
};

export const SeverityChip = ({ severity, ...rest }: Props) => {
  const mappedColor =
    severity && severityToColor[severity]
      ? severityToColor[severity]
      : 'neutral';

  return (
    <StatusChipV2
      label={capitalize(severity)}
      color={mappedColor}
      variant="subtle"
      {...rest}
    />
  );
};
